import { AccountMergingState, AccountMergingStepName } from 'User/types/accountMerging';

const initialState: AccountMergingState = {
  isExists: false,
  steps: [
    {
      stepName: AccountMergingStepName.ADD_MOBILE_NUMBER,
      sendOtpExhausted: false,
    },
  ],
  linkedEmail: '',
  changeMob: false,
  previousPageName: '',
  mobileNumber: '',
  emailId: '',
  root: '',
};

export default initialState;
